'use client';
import Box from '@mui/material/Box';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { RESPONSIVE_MARGIN } from '@/functions/createTheme';
import { type BreadCrumbsContent, useBreadCrumbs } from './hooks';

export type BreadcrumbsProps = {
  customerSetting: CustomerSetting;
  currentTitle: string;
  searchParams?: SearchParams;
  today?: boolean;
  /**
   * 指定した場合、トップの直下に表示される
   * ex: { label: '水戸市', href: '/mito' }
   * -> トップ > 水戸市 > {諸条件}
   */
  subPages?: BreadCrumbsContent['links'];
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  customerSetting,
  currentTitle,
  searchParams,
  today,
  subPages
}) => {
  const { links, current } = useBreadCrumbs({
    customerSetting,
    currentTitle,
    searchParams,
    today,
    subPages
  });

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'block' },
        mt: RESPONSIVE_MARGIN,
        mx: { xs: 1, sm: 0 }
      }}
      role="presentation"
    >
      <MuiBreadcrumbs aria-label="breadcrumb">
        {links.map((link) => (
          <Link
            key={link.href}
            underline="hover"
            color="inherit"
            href={link.href}
          >
            {link.label}
          </Link>
        ))}
        <Typography color="primary">{current}</Typography>
      </MuiBreadcrumbs>
    </Box>
  );
};
